import Dialog from 'Components/Molecules/Dialog/Dialog';
import PropTypes from 'prop-types';
import { useEffect } from 'react';

export default function DialogBookDemo({ open, onClose }) {
    useEffect(() => {
        if (open) {
            const script = document.createElement('script');
            script.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
            script.type = 'text/javascript';
            script.async = true;
            document.body.appendChild(script);

            return () => {
                document.body.removeChild(script);
            };
        }
    }, [open]);

    return (
        <Dialog open={open} onClose={onClose} className="max-w-4xl px-0">
            <div className="pt-6">
                <div
                    className="meetings-iframe-container"
                    data-src="https://demo.banktrack.com/meetings/banktrack/demo5?embed=true"
                />
            </div>
        </Dialog>
    );
}

DialogBookDemo.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};
